import { trackEvent } from 'helpers/analytics'
import { MESSAGE_ROLES, MESSAGE_TYPES } from './index'

export const REQUIREMENT_PROFILE_JOYRIDE_STEPS_CONFIG = [
  {
    id: 'requirement_profile_step_career_overview',
    target: '#requirement-profile-component',
    title: 'discover.assistant_onboarding.3.title',
    description: 'discover.assistant_onboarding.3.description',
    placement: 'right',
    disableBeacon: true,
    ctaLabel: 'discover.assistant_onboarding.3.cta'
  },
  {
    id: 'requirement_profile_step_profile_component',
    target: '#requirement_profile_skills_section_0_scala',
    title: 'discover.assistant_onboarding.4.title',
    description: 'discover.assistant_onboarding.4.description',
    placement: 'right-start',
    disableBeacon: true,
    ctaLabel: 'discover.assistant_onboarding.4.cta'
  },
  {
    id: 'requirement_profile_step_skills',
    target: '#requirement_profile_skills_section_0_title',
    title: 'discover.assistant_onboarding.5.title',
    description: 'discover.assistant_onboarding.5.description',
    placement: 'top',
    disableBeacon: true,
    ctaLabel: 'discover.assistant_onboarding.5.cta'
  },
  {
    id: 'requirement_profile_step_skills_1',
    target: null,
    title: 'discover.assistant_onboarding.6.title',
    description: 'discover.assistant_onboarding.6.description',
    placement: 'top',
    disableBeacon: true,
    ctaLabel: 'discover.assistant_onboarding.6.cta',
    isCtaPulsing: true
  }
]

export const startRequirementProfileAssistantFlow = ({
  sendMessageToAssistant,
  setAssistantSpotlightSelector,
  stepIndex = 0,
  onFinish,
  t
}) => {
  const step = REQUIREMENT_PROFILE_JOYRIDE_STEPS_CONFIG[stepIndex]

  if (!step) {
    if (typeof setAssistantSpotlightSelector === 'function') {
      setAssistantSpotlightSelector(null)
    }
    return
  }

  if (typeof setAssistantSpotlightSelector === 'function') {
    setAssistantSpotlightSelector(step.target)
  }

  if (step.target === null) {
    setAssistantSpotlightSelector(null)
  }

  sendMessageToAssistant({
    id: step.id,
    title: t(step.title),
    description: t(step.description),
    role: MESSAGE_ROLES.ASSISTANT,
    type: MESSAGE_TYPES.TEXT,
    spotlightSelector: step.target,
    detailsLink: step.detailsLink,
    cta: {
      title: t(step.ctaLabel) ?? 'Weiter',
      isPulsing: step.isCtaPulsing || false,
      onClick: () => {
        const nextStepIndex = stepIndex + 1
        const hasNextStep =
          nextStepIndex < REQUIREMENT_PROFILE_JOYRIDE_STEPS_CONFIG.length

        if (!hasNextStep) {
          if (typeof setAssistantSpotlightSelector === 'function') {
            setAssistantSpotlightSelector(null)
          }

          onFinish()

          return
        }

        trackEvent(
          stepIndex === 0
            ? 'discover_requirement_profile_full_continued'
            : stepIndex === 1
              ? 'discover_requirement_profile_ideal_transition_range_continued'
              : stepIndex === 2
                ? 'discover_requirement_profile_more_dimension_info_continued'
                : 'discover_requirement_profile_completed'
        )

        startRequirementProfileAssistantFlow({
          sendMessageToAssistant,
          setAssistantSpotlightSelector,
          stepIndex: nextStepIndex,
          onFinish,
          t
        })
      }
    }
  })
}
